export enum RomexisBridgeConfiguration {
  V4 = 'v4',
  V5 = 'v5',
  V5Legacy = 'v5Legacy',
}

export interface IRomexisBridgeConfigurationOption {
  type: RomexisBridgeConfiguration;
  label: string;
  description: string;
}

export const ROMEXIS_BRIDGE_CONFIGURATION_OPTIONS: IRomexisBridgeConfigurationOption[] =
  [
    {
      type: RomexisBridgeConfiguration.V5,
      label: 'Romexis 5+',
      description: 'Compatible with Romexis 5/6/7.',
    },
    {
      type: RomexisBridgeConfiguration.V5Legacy,
      label: 'Romexis 5+ (Legacy)',
      description: 'Use if you experience issues with standard V5 mode.',
    },
    {
      type: RomexisBridgeConfiguration.V4,
      label: 'Romexis 4.x',
      description: 'Enables V4 compatibility. Image syncing not supported.',
    },
  ];
